/* loaded by smart-asset */
export default require("./square-regular~ZGzDWMGe.svg")